<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex">
          <div class="form-base__title">
            Реквизиты документа, подтверждающего должность или статус
            представителя
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" v-bind="attrs" v-on="on"
                >{{ mdiAlertCircleOutline }}
              </v-icon>
            </template>
            <span>
              Например, устав, приказ о назначении на должность, удостоверение
              адвоката и другие документы
            </span>
          </v-tooltip>
        </div>
      </v-col>

      <v-col cols="9">
        <v-text-field
          v-model="$v.statusDocument.name.$model"
          :errorMessages="getValidationErrorText($v.statusDocument.name)"
          label="Наименование документа"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата выдачи"
          :value="$v.statusDocument.docDate.$model"
          @change="$v.statusDocument.docDate.$model = $event"
          :errorMessage="$v.statusDocument.docDate"
          :max="new Date().toISOString()"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="$v.statusDocument.issuer.$model"
          :errorMessages="getValidationErrorText($v.statusDocument.issuer)"
          label="Кем выдан"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="$v.statusDocument.series.$model"
          :errorMessages="getValidationErrorText($v.statusDocument.series)"
          label="Серия документа"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="$v.statusDocument.number.$model"
          :errorMessages="getValidationErrorText($v.statusDocument.number)"
          label="Номер документа"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AttachDocumentSingle
          :value="{
            file: $v.statusDocument.file.$model,
            fileSig: $v.statusDocument.fileSig.$model,
          }"
          :error-messages="getValidationErrorText($v.statusDocument.file)"
          @change="
            $v.statusDocument.file.$model = $event.file;
            $v.statusDocument.fileSig.$model = $event.fileSig;
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import { mdiAlertCircleOutline } from '@mdi/js';
import DateFieldCustom from './DateFieldCustom';
import { and, maxLength, required, requiredIf } from 'vuelidate/lib/validators';
import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  EMOJI,
  getValidationErrorText,
} from '@/utils/validate';
import { isNotEmptyObjectCheck } from '@/utils/common';

export default {
  name: 'ConfirmationStatusForm',
  components: { DateFieldCustom, AttachDocumentSingle },
  validations() {
    return {
      statusDocument: {
        name: {
          required,
          maxLength: maxLength(1000),
          EMOJI,
        },
        docDate: {
          required: requiredIf(
            () =>
              this.statusDocument.series ||
              this.statusDocument.name ||
              this.statusDocument.issuer ||
              this.statusDocument.number ||
              this.statusDocument.file ||
              this.statusDocument.fileSig
          ),
          DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
        },
        issuer: {
          required: requiredIf(
            () =>
              this.statusDocument.series ||
              this.statusDocument.name ||
              this.statusDocument.docDate ||
              this.statusDocument.number ||
              this.statusDocument.file ||
              this.statusDocument.fileSig
          ),
          maxLength: maxLength(1000),
          EMOJI,
        },
        series: {
          maxLength: maxLength(25),
          EMOJI,
        },
        number: {
          required: requiredIf(
            () =>
              this.statusDocument.series ||
              this.statusDocument.name ||
              this.statusDocument.issuer ||
              this.statusDocument.docDate ||
              this.statusDocument.file ||
              this.statusDocument.fileSig
          ),
          maxLength: maxLength(50),
          EMOJI,
        },
        file: {
          required,
        },
        fileSig: {
          required,
        },
      },
    };
  },
  data: () => ({
    mdiAlertCircleOutline,
    getValidationErrorText,
    statusDocument: {
      type: 'CONFIRMATION_OF_STATUS',
      name: '',
      docDate: '',
      issuer: '',
      series: '',
      number: '',
      file: null,
      fileSig: null,
    },
  }),
  props: {
    document: {
      type: Object,
    },
  },
  created() {
    this.reset();
    if (isNotEmptyObjectCheck(this.document)) {
      this.statusDocument = this.document;
    }
  },
  methods: {
    touch() {
      this.$v.$touch();
      return this.statusDocument.name ? this.$v.$invalid : true;
    },

    async upload() {
      return !this.touch() ? this.statusDocument : null;
    },
    reset() {
      this.statusDocument.name = '';
      this.statusDocument.docDate = '';
      this.statusDocument.issuer = '';
      this.statusDocument.series = '';
      this.statusDocument.file = null;
      this.statusDocument.fileSig = null;
      this.$v.$reset();
    },
  },
};
</script>

<style scoped></style>
